import React, { useState, useEffect } from "react";
import { initGA, initGA2, initGTM } from "../../utils";

import { FloatingDiv, Info, Text, Hyperlink, Button, CloseButton } from "./styles";

export default function CookiesAndTerms() {
	const [isOpen, setIsOpen] = useState(false);
	const termsLink =
		"https://trademap.com.br/termos-de-uso-e-politica-de-privacidade/#:~:text=O%20Usu%C3%A1rio%2C%20ao%20aceitar%20os,pela%20Valemobi%20para%20quaisquer%20finalidades";

	useEffect(() => {
		function verifyAcceptedCookies() {
			const isAccepted = localStorage.getItem("cookies");
			setIsOpen(!isAccepted);

			if (isAccepted) startAnalytics();
		}

		verifyAcceptedCookies();
	}, []);

	function acceptTermsCookies() {
		setIsOpen(false);
		localStorage.setItem("cookies", true);
		startAnalytics();
	}

	function startAnalytics() {
		initGA();
		initGA2();
		initGTM();
	}

	function close() {
		setIsOpen(false);
	}

	return (
		<FloatingDiv className={isOpen ? "visible" : ""}>
			<CloseButton onClick={() => close()}>
				<svg
					aria-hidden="true"
					focusable="false"
					data-prefix="fas"
					data-icon="times"
					role="img"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 352 512"
					className="svg-inline--fa fa-times fa-w-11"
				>
					<path
						fill="currentColor"
						d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
						className=""
					></path>
				</svg>
				<i className="fas fa-times"></i>
			</CloseButton>
			<Info>
				<Text>
					O Portal Trademap utiliza cookies do Google para analisar tráfego e
					personalizar anúncios. Isso é feito para que você tenha a melhor
					experiência possível enquanto navega.
				</Text>
				<Hyperlink target="_blank" href={termsLink}>
					Veja a Política de privacidade
				</Hyperlink>
			</Info>
			<Button onClick={() => acceptTermsCookies()}>Eu aceito!</Button>
		</FloatingDiv>
	);
}
